export default __webpack_public_path__ + "static/media/dinner5.1b3871b6.png";